module.exports = __webpack_public_path__ + "img/ganzhi.c57986b9.svg";